import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Logger from '../lib/analytics/logger';
import { setIsConnected } from '../state/actions/device';
import { AxiosRequest } from '../state/api/services/axios';
import { store } from '../state/store';
import Utils from '../utils';
import AppInterface from './AppInterface';
import DeviceInfo from './DeviceInfo';
import { ServerResponseKeys } from './Constants';
var RequestHelper = {
  /**
   * Helper method to send GET request
   * @async
   * @public
   * @param {Object} params - Body params for the fetch request
   * @param {string} params.endpoint - The endpoint for the request
   * @param {boolean} [params.logPromise] - If true, log the promise
   * @param {boolean} withExtras - Flag for handling extras
   * @returns {Object} The data object parsed from server response
   */
  apiGet: function () {
    var _apiGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, withExtras) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!withExtras) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return this.apiRequest('GET', params);

            case 3:
              _context.t0 = ServerResponseKeys.CALL_RESPONSE;
              return _context.abrupt("return", _context.sent[_context.t0]);

            case 5:
              _context.next = 7;
              return this.apiRequest('GET', params);

            case 7:
              return _context.abrupt("return", _context.sent);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function apiGet(_x, _x2) {
      return _apiGet.apply(this, arguments);
    }

    return apiGet;
  }(),

  /**
   * Helper method to send POST request
   * @async
   * @public
   * @param {Object} params - Body params for the fetch request
   * @param {String} params.endpoint - The endpoint for the request
   * @param {Object} params.body - Body of the request
   * @param {boolean} [params.logPromise] - If true, log the promise
   * @param {boolean} [params.logJSON] - If true, log the full json response.
   * @param {boolean} [params.logRaw] - If true, log the raw response before attempting to parse it.
   * @param {boolean} withExtras - Flag for handling extras
   * @returns {Object} The data object parsed from server response
   */
  apiPost: function () {
    var _apiPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params, withExtras) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!withExtras) {
                _context2.next = 5;
                break;
              }

              _context2.next = 3;
              return this.apiRequest('POST', params);

            case 3:
              _context2.t0 = ServerResponseKeys.CALL_RESPONSE;
              return _context2.abrupt("return", _context2.sent[_context2.t0]);

            case 5:
              _context2.next = 7;
              return this.apiRequest('POST', params);

            case 7:
              return _context2.abrupt("return", _context2.sent);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function apiPost(_x3, _x4) {
      return _apiPost.apply(this, arguments);
    }

    return apiPost;
  }(),

  /**
   * Helper method to abstract away fetch request, with minimal error handling
   * @async
   * @private
   * @param {String} methodType - 'GET' or 'POST'
   * @param {Object} params - Body params for the fetch request
   * @param {Bool} tryRestartSession - if set to true then a failure will try to restart session
   * @returns {Object} The data object parsed from server response
   */
  apiRequest: function () {
    var _apiRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(methodType, params) {
      var requestBody, mobileParams, fetchParams, failedFetchErr, isConnected;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("[\u2191 ".concat(methodType, " \u2191] ").concat(params.endpoint, " - ").concat(params.body ? JSON.stringify(params.body, null, 2) : 'no body'));
              requestBody = params.body;

              if (!params.isBinary) {
                mobileParams = Utils.isReactNative() && !params.baseUrl ? {
                  uid: DeviceInfo.getUID(),
                  device: DeviceInfo.getDevice(),
                  sysver: DeviceInfo.getSysVer(),
                  bundlever: DeviceInfo.getBundleVer(),
                  bundleid: DeviceInfo.getBundleId(),
                  uuid: DeviceInfo.getUID()
                } : {};
                requestBody = _objectSpread(_objectSpread({}, params.body), mobileParams);
              }

              fetchParams = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                method: methodType,
                mode: 'cors',
                redirect: 'follow',
                referrer: 'no-referrer'
              }, params.headers && {
                headers: params.headers
              }), params.baseUrl && {
                baseURL: params.baseUrl
              }), params.ignoreCache && {
                cache: {
                  ignoreCache: params.ignoreCache
                }
              }), methodType === 'POST' && {
                data: {
                  body: requestBody,
                  raw: params.raw,
                  isBinary: params.isBinary
                }
              });
              _context3.prev = 4;
              _context3.next = 7;
              return AxiosRequest(params.endpoint, methodType, fetchParams);

            case 7:
              return _context3.abrupt("return", _context3.sent);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](4);

              /**
               * If we receive TypeError: Failed to fetch from the fetch,
               * then we know that the call did not return
               */
              failedFetchErr = _context3.t0.toString() === 'TypeError: Failed to fetch'; // when params.baseUrl is given, it is an API call to an external resource so no need to restart session

              isConnected = store.getState().device.isConnected;

              if (!(!failedFetchErr && isConnected && !params.baseUrl)) {
                _context3.next = 18;
                break;
              }

              throw _context3.t0;

            case 18:
              if (!(isConnected && !params.shouldSkipIsConnectedCheck)) {
                _context3.next = 23;
                break;
              }

              _context3.next = 21;
              return store.dispatch(setIsConnected(false));

            case 21:
              Utils.addOnlineConnectionListener(AppInterface.initApp);
              throw 'An unexpected error has occurred, please try again later.';

            case 23:
              return _context3.abrupt("return", false);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 10]]);
    }));

    function apiRequest(_x5, _x6) {
      return _apiRequest.apply(this, arguments);
    }

    return apiRequest;
  }(),
  getPreviousXp: function getPreviousXp() {
    return store.getState().xpInfo.xp;
  },
  removePasswordFromRequestBody: function removePasswordFromRequestBody(body) {
    if (!body || typeof body !== 'string') {
      return '';
    }

    var findPassIndex = body.indexOf('&password');
    var newBodyString;

    if (findPassIndex >= 0) {
      newBodyString = body.substr(0, findPassIndex);
      var findSecondPart = body.indexOf('&login_type');

      if (findSecondPart > 0) {
        var secondPart = body.substr(findSecondPart);
        newBodyString = newBodyString + secondPart;
      }

      return newBodyString;
    }

    return body;
  }
};
export default RequestHelper;